export class ScreenCodeConstant {

  //#region Properties

  public static readonly spinnerDemo = 'SPINNER_DEMO';

  public static readonly bannerDemo = 'BANNER_DEMO';

  public static readonly landing = 'LANDING';

  public static readonly validationSummarizerDemo = 'VALIDATION_SUMMARIZER_DEMO';

  public static readonly dialogDemo = 'DIALOG_DEMO';

  public static readonly smartNavigatorDemo = 'SMART_NAVIGATOR_DEMO';

  public static readonly smartNavigatorTab01Demo = 'SMART_NAVIGATOR_TAB_01_DEMO';

  public static readonly smartNavigatorTab02Demo = 'SMART_NAVIGATOR_TAB_02_DEMO';

  public static readonly smartNavigatorTab03Demo = 'SMART_NAVIGATOR_TAB_03_DEMO';

  //#endregion

}
